import { type Maybe, type QrCode, QrCodeImageFormat } from "../../gql-generated/types";

export type ScanCodeFormat = "svg" | "webp";

export interface ScanCode {
    previewUrl: string;
    downloadUrl: string;
    downloadFormat: ScanCodeFormat;
}

const isHttpsUrl = (url: string): boolean => {
    try {
        return new URL(url).protocol === "https:";
    } catch {
        return false;
    }
};

const findImageUrl = (qrCode: QrCode, format: QrCodeImageFormat): string | undefined =>
    qrCode.imagesList.find((image) => image.format === format && isHttpsUrl(image.imageUrl))?.imageUrl;

export const getLensScanCode = (qrCode: Maybe<QrCode> | undefined): ScanCode | undefined => {
    if (!qrCode) {
        return undefined;
    }
    const svgUrl = findImageUrl(qrCode, QrCodeImageFormat.ImageFormatSvg);
    const webpUrl = findImageUrl(qrCode, QrCodeImageFormat.ImageFormatWebp);
    // SVG scales for print; WebP tops out at 360px, so it is only downloaded when no SVG exists.
    if (svgUrl) {
        return { previewUrl: webpUrl ?? svgUrl, downloadUrl: svgUrl, downloadFormat: "svg" };
    }
    if (webpUrl) {
        return { previewUrl: webpUrl, downloadUrl: webpUrl, downloadFormat: "webp" };
    }
    return undefined;
};
